import { useState } from "react"
import Tooltip from "../../Tooltip"
import { useAuth0 } from "@auth0/auth0-react"
import {
	getCurrentTime,
	getFirstOpenDateToday,
	getScheduleLockTime,
	convertMinutesTo12HHAMPMSingleDigit
} from "../../../utils/generalUtils"
import { useSelector } from "react-redux"
import useFetchSettings from "../../../hooks/useFetchSettings"

/**
 * Returns a future staffing button that is only enabled if the current time is before the schedule lock time
 * (11:00 AM every day)
 *
 * @param {Object} props
 * @param {string} props.btnSelect
 * @param {function} props.onClick
 *
 * @returns {JSX.Element}
 */
const FutureStaffingButton = ({ btnSelect, onClick }) => {
	const { user } = useAuth0()

	const testEnvironment = user.org_id === "org_lkg3WMhi3Q2l92iT"

	const sandbox = useSelector(state => state.sandbox.isSandboxMode)
	const isTomorrowMode = useSelector(state => state.tomorrow.isTomorrowMode)
	const { settingsData } = useFetchSettings()
	const centerOpen = settingsData?.centerOpen
	const centerClosedDates = settingsData?.center_closed_dates || []

	const currentTime = getCurrentTime(sandbox, isTomorrowMode)

	// Calculate lock time based on whether today ends early
	const today = getFirstOpenDateToday(centerOpen, testEnvironment, centerClosedDates)
	const lockTime = getScheduleLockTime(
		today,
		settingsData?.close_time_minutes || [],
		settingsData?.holiday_close_time_minutes || [],
		settingsData?.holidays || []
	)
	const isEnabled = testEnvironment ? true : currentTime < lockTime

	const [isHovered, setIsHovered] = useState(false)

	return (
		<div className="relative">
			<button
				className={`px-4 py-2 rounded-md items-center ${
					btnSelect === "Future Staffing"
						? "text-white bg-customBlue"
						: "text-black bg-gray-100 hover:bg-gray-200"
				} ${!isEnabled && "opacity-50 cursor-not-allowed"}`}
				onClick={onClick}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
			>
				Future Staffing
			</button>

			{!isEnabled && isHovered && (
				<Tooltip
					content={`Future staffing can only be modified before ${convertMinutesTo12HHAMPMSingleDigit(lockTime)}, after which the schedule is locked`}
				>
					<div className="fixed transform -translate-x-1/2 mt-1 w-64 bg-gray-800 text-white text-sm rounded-md py-2 px-4 shadow-lg z-50">
						Future staffing can only be modified before{" "}
						{convertMinutesTo12HHAMPMSingleDigit(lockTime)}, after which the schedule is
						locked
					</div>
				</Tooltip>
			)}
		</div>
	)
}

export default FutureStaffingButton
